import React from 'react';

const Button = ({ onClick, disabled, text, back }) => (
  <>
   {back && (
    <button
      onClick={back}
      className="button absolute bottom-[20%] text-white font-bold py-2 px-4 rounded mt-4 disabled:opacity-50 w-[80px] h-[30px] md:w-[120px] md:h-[40px] text-[16px] md:text-[20px] top-[90%] md:top-[85%] ml-[-68px] md:ml-[-102px]"
    >
      <span>返回</span>
    </button>
   )}
    <button
      onClick={onClick}
      disabled={disabled}
      className={"button absolute bottom-[20%] text-white font-bold py-2 px-4 rounded mt-4 disabled:opacity-50 w-[120px] h-[30px] md:w-[180px] md:h-[40px] text-[16px] md:text-[20px] top-[90%] md:top-[85%] " +  (back ? "back ml-[45px] md:ml-[60px]" : "")}
    >
      <span>{text}</span>
    </button>
  </>
);

export default Button;